import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const navigate = useNavigate();
  const { direction } = useLanguage();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className={`min-h-screen flex items-center justify-center bg-synagogue-light ${direction === 'rtl' ? 'rtl' : 'ltr'}`}>
      <div className="text-center max-w-md p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-6xl font-bold text-synagogue-blue mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-synagogue-blue mb-4">
          {direction === 'rtl' ? "העמוד לא נמצא" : "Page Not Found"}
        </h2>
        <p className="text-gray-600 mb-8">
          {direction === 'rtl' 
            ? "העמוד שחיפשת אינו קיים או שהוסר. נסה לחזור לדף הבית." 
            : "The page you were looking for doesn't exist or has been moved. Try going back to the homepage."}
        </p>
        <Button 
          onClick={handleGoHome}
          className="bg-synagogue-gold hover:bg-synagogue-blue text-white"
        >
          {direction === 'rtl' ? "חזרה לדף הבית" : "Back to Homepage"}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
